'use client'

import React, { ReactNode } from 'react';
import { IPage, IPlugin } from '../../types';
import { StyledDiv } from './whyUseWidget.styles';

export interface IWhyUseBenefit {
    title: string;
    text: string;
    icon?: ReactNode;
}

export const WhyUseWidget = ({
    widget,
    page,
    dropPlus,
    overrideTitle,
    overrideBenefits,
}: {
    widget: IPlugin;
    page?: IPage;
    dropPlus?: boolean;
    overrideTitle?: string;
    overrideBenefits?: IWhyUseBenefit[];
}) => {
    const isBranded = !!overrideBenefits;
    const benefits =
        overrideBenefits ??
        (page ? page.rewrites.keyBenefits : widget.keyBenefits);

    return (
        <StyledDiv className={isBranded ? 'branded' : undefined}>
            <h2>
                {overrideTitle ? (
                    overrideTitle
                ) : (
                    <>
                        Why Should You Use the <span>{widget.name}</span> Widget
                        {dropPlus ? '?' : '+?'}
                    </>
                )}
            </h2>
            <div className="benefits">
                {benefits.map((benefit, idx) => (
                    <div key={`${benefit.title}-${idx}`} className="card">
                        {isBranded && (benefit as IWhyUseBenefit).icon && (
                            <span className="icon" aria-hidden="true">
                                {(benefit as IWhyUseBenefit).icon}
                            </span>
                        )}
                        <h3>{benefit.title}</h3>
                        <p>{benefit.text}</p>
                    </div>
                ))}
            </div>
        </StyledDiv>
    );
};
